import {Row, Col, Button, Image} from "react-bootstrap"
import { Link } from 'react-router-dom'

import useWindowDimensions from "../../utils/useWindowDimensions";
import burgerMenuIcon from '../../assets/icons/burgerMenu.png';

import Logo from "../../assets/logos/Logo_White-01.png";
import styles from "./Header.module.css";


function Header({ burgerMenuProp }){
    const { height, width } = useWindowDimensions();
    return (
        <Row className={styles.headerContainer}>
            <Col className={styles.imageCol}>
                <Link to="/">
                    <Image src={Logo} className={styles.logo}></Image>
                </Link>
            </Col>
            {width > 992 ? <Col className="d-flex justify-content-end align-items-center">
                <Link to="/"><div className={styles.topMenuText}>Vote</div></Link>
                <Link to="/propose"><div className={styles.topMenuText}>Make a Proposal</div></Link>
                <Link to="/buy-voton">
                    <Button className={styles.topButtons}>
                        <div className={styles.topButtonText}>Buy Token</div>
                    </Button>
                </Link>
            </Col> : <Col className="d-flex justify-content-end align-items-center">
                <div onClick={() => burgerMenuProp(true)}>
                    <img src={burgerMenuIcon} className={styles.burgetMenuIcon} />
                </div>
            </Col>}
        </Row>
    );
}

export default Header;
